// API Call URL
export const URL =  process.env.REACT_APP_SEVASADHANA_API_URL

// TMCE (HTML Component) API Key
export const API_USERNAME = process.env.REACT_APP_API_USERNAME
export const API_PASSWORD = process.env.REACT_APP_API_PASSWORD